export enum IndicatorGroup {
  DADOS_CADASTRAIS = 'Dados cadastrais',
  CONSULTAS = 'Consultas',
  SCORE = 'Score',
  ACOES_CIVEIS = 'Ações cíveis',
  FALENCIAS = 'Falências',
  NEGATIVACOES = 'Negativações',
  PROTESTOS = 'Protestos',
  CHEQUES_SEM_FUNDOS = 'Cheques sem fundos',
  PERCENTUAL_QUADRO_SOCIETARIO = 'Percentual do quadro societário',
}
